import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { DeleteSupportDocs as UseCaseRemoteDeleteSupportDocs } from '~/domain/usecases/supportDoc/remote';

import { RemoteDeleteSupportDocs } from '~/data/repository/supportDoc';

export const makeRemoteDeleteSupportDocs = (): UseCaseRemoteDeleteSupportDocs =>
  new RemoteDeleteSupportDocs(makeApiUrl('/supportDocs/'), makeHttpClient());
